// removed by extract-text-webpack-plugin
module.exports = {"main":"Tour__main___3eI9g","items":"Tour__items___FSWnU","item":"Tour__item___38sHu"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Tour/Tour.css
// module id = 757
// module chunks = 0